(function () {
  "use strict";
  // Result page for the Swoveralls quiz. Runs on Shopify (same origin as /products/*.js and the
  // cart API) and in local dev, where dev.js proxies those routes.
  var CFG = Object.assign({ data: "/swq-data.json", api: "" }, window.SWQ || {});
  var root = document.getElementById("swq-result");
  var params = new URLSearchParams(location.search);
  var sid = params.get("qsid") || "";
  var DATA, PAGE, aid, handle, product = null, variantId = null, adding = false;

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function log(event, extra) {
    if (CFG.api === null) return; // no quiz API configured on this host
    try {
      var body = JSON.stringify(Object.assign({ event: event, session_id: sid, archetype: aid, product: handle }, extra || {}));
      navigator.sendBeacon(CFG.api + "/api/log", new Blob([body], { type: "text/plain" }));
    } catch (err) {
      console.warn("result log failed", err);
    }
  }

  var CHECK = '<svg class="swq-check" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="12" fill="#1D7CF2"/><path d="M7 12.5l3.2 3.2L17.2 8.7" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function slider(s) {
    // Junip scores run 1 to 5; the marker sits on a 4-segment track like the one on product pages.
    var pct = Math.max(0, Math.min(100, (s.value - 1) * 25));
    return '<div class="swq-slider"><div class="swq-slider-name">' + esc(s.name) + "</div>" +
      '<div class="swq-slider-track" role="img" aria-label="' + esc(s.name + ": " + s.value + " out of 5") + '">' +
        "<span></span><span></span><span></span><span></span>" +
        '<i style="left:' + pct + '%"></i></div>' +
      '<div class="swq-slider-labels"><span>' + esc(s.left) + "</span>" + (s.center ? "<span>" + esc(s.center) + "</span>" : "") + "<span>" + esc(s.right) + "</span></div></div>";
  }

  function quote(q) {
    // build.py only accepts 5-star reviews from verified buyers, with a name on file.
    var r = (DATA.reviews || {})[q[1]] || {};
    return '<figure class="swq-review">' +
      '<div class="swq-stars" aria-label="5 out of 5 stars">\u2605\u2605\u2605\u2605\u2605</div>' +
      "<blockquote>\u201c" + esc(q[0]) + "\u201d</blockquote>" +
      '<figcaption class="swq-reviewer"><b>' + esc(r.name || "Swoveralls customer") + "</b>" +
        (r.verified ? '<span class="swq-verified">' + CHECK + "Verified buyer</span>" : "") +
        (r.size ? '<span class="swq-review-size">Usually wears ' + esc(r.size) + "</span>" : "") +
      "</figcaption>" +
      (r.sliders && r.sliders.length ? '<div class="swq-sliders">' + r.sliders.map(slider).join("") + "</div>" : "") +
    "</figure>";
  }

  function render() {
    var M = DATA.quiz;
    var own = Object.prototype.hasOwnProperty;
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem("swq_result_" + sid) || "{}") || {}; } catch (e) { console.info("sessionStorage unavailable", e); }
    var body = saved.body && own.call(DATA.body_blocks, saved.body) ? DATA.body_blocks[saved.body] : null;
    var said = typeof saved.said === "string" ? saved.said : null;

    var pick = saved.pick === true;
    // Carousel: this persona's picks first, then every other style in the quiz catalog.
    var list = PAGE.alts.slice();
    Object.keys(M.products).forEach(function (h) {
      if (list.indexOf(h) === -1 && M.products[h].carousel !== false) list.push(h);
    });
    var tiles = list.map(function (h) {
      var p = M.products[h];
      return '<button type="button" class="swq-tile" data-h="' + esc(h) + '" aria-pressed="false">' +
        '<img src="' + esc(p.image) + '&width=300" alt="" loading="lazy">' +
        '<span class="swq-tile-name">' + esc(p.name.replace("Swoveralls in ", "").replace("Grid Fleece Swoveralls in ", "Grid Fleece ")) + "</span>" +
        '<span class="swq-tile-price">$' + p.price + "</span></button>";
    }).join("");
    var carousel = '<div class="swq-carousel-wrap' + (pick ? " swq-carousel-lead" : "") + '">' +
      '<div class="swq-carousel-head"><span class="swq-eyebrow-sm">' + (pick ? "Pick your style" : "More styles") + "</span>" +
      '<span class="swq-carousel-hint">Swipe for more</span></div>' +
      '<div class="swq-carousel" id="swq-carousel" role="group" aria-label="Styles">' + tiles + "</div></div>";

    // Grid areas: one column on phones (hero, said, product, body, more); two columns on
    // desktop with the product card pinned on the right.
    root.innerHTML =
      '<div class="swq-result-grid">' +
      '<section class="swq-lp-hero swq-a-hero" style="background:' + esc(PAGE.bg) + ";color:" + esc(PAGE.fg) + '">' +
        '<div class="swq-eyebrow" style="background:' + esc(PAGE.pill) + ";color:" + esc(PAGE.pill_fg) + '">' + esc(PAGE.eyebrow) + "</div><h1>" + esc(PAGE.h1) + "</h1><p>" + esc(PAGE.sub) + "</p></section>" +
      (said ? '<section class="swq-card swq-said swq-a-said" style="background:' + esc(PAGE.said_bg) + '"><div class="swq-eyebrow-sm">Your waistband\u2019s crime</div><p>“' + esc(said) + '”</p></section>' : "") +
      '<section class="swq-card swq-product swq-a-product" id="swq-product">' +
        (pick ? carousel : "") +
        '<img id="swq-p-img" alt="">' +
        '<h3 id="swq-p-name"></h3>' +
        '<div class="swq-price"><span id="swq-p-price"></span><small>' + esc(DATA.review_line) + "</small></div>" +
        '<div class="swq-sizes" id="swq-sizes" role="group" aria-label="Choose your size"></div>' +
        '<div class="swq-size-note" id="swq-size-note"></div>' +
        '<button class="swq-btn" id="swq-add" type="button">Pick a size</button>' +
        '<div class="swq-error" id="swq-error" role="alert"></div>' +
        '<ul class="swq-terms" id="swq-terms"></ul>' +
        (pick ? "" : carousel) +
      "</section>" +
      (body ? '<section class="swq-card swq-bodyblock swq-a-body"><div class="swq-eyebrow-sm">' + esc(body.eyebrow) + "</div><p>" + esc(body.text) + "</p>" + body.quotes.map(quote).join("") + '<p class="swq-disclaimer">Customer experiences, not medical advice.</p></section>' : "") +
      '<div class="swq-a-more">' +
        '<h2 class="swq-section-title">Why this pair fits how you work</h2>' +
        '<div class="swq-pains">' + PAGE.pains.map(function (p) { return '<div class="swq-pain"><b>' + esc(p[0]) + "</b><span>" + esc(p[1]) + "</span></div>"; }).join("") + "</div>" +
        '<h2 class="swq-section-title">From people who already own them</h2>' + PAGE.quotes.map(quote).join("") +
        '<p class="swq-small"><a href="' + esc(CFG.quizUrl || "/") + '">Retake the quiz</a></p>' +
      "</div></div>" +
      '<div class="swq-sticky" id="swq-sticky"><button class="swq-btn" id="swq-add2" type="button">Pick a size</button></div>';

    Array.prototype.forEach.call(root.querySelectorAll(".swq-tile"), function (el) {
      el.addEventListener("click", function () {
        show(el.dataset.h);
        // Keep the link in sync so a refresh or shared link shows the style they picked.
        try {
          var u = new URL(location.href);
          u.searchParams.set("p", el.dataset.h);
          history.replaceState(null, "", u.toString());
        } catch (e) { console.info("could not update URL", e); }
        log("lp_view", { answer_id: "carousel_pick", product: el.dataset.h });
        document.getElementById("swq-p-img").scrollIntoView({ behavior: "smooth", block: "nearest" });
      });
    });
    ["swq-add", "swq-add2"].forEach(function (id) { document.getElementById(id).addEventListener("click", addToBag); });
    // Hide the bottom bar while the card's own button or the style carousel is on screen,
    // so it never doubles the button or covers the tiles.
    if ("IntersectionObserver" in window) {
      var visible = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
        document.getElementById("swq-sticky").classList.toggle("swq-hidden", !!(visible["swq-add"] || visible["swq-carousel"]));
      });
      io.observe(document.getElementById("swq-add"));
      io.observe(document.getElementById("swq-carousel"));
    }
  }

  // Before a size is chosen the button stays clickable and takes them to the sizes,
  // so the only call to action on screen never looks dead.
  function setButtons(label, ready) {
    ["swq-add", "swq-add2"].forEach(function (id) {
      var b = document.getElementById(id);
      b.textContent = label;
      b.classList.toggle("swq-pending", !ready);
    });
  }

  function show(h) {
    var M = DATA.quiz;
    handle = h;
    variantId = null;
    var p = M.products[h];
    document.getElementById("swq-p-img").src = p.image;
    document.getElementById("swq-p-img").alt = p.name;
    document.getElementById("swq-p-name").textContent = p.name;
    document.getElementById("swq-p-price").textContent = "$" + p.price;
    document.getElementById("swq-sizes").innerHTML = "";
    document.getElementById("swq-size-note").textContent = "Sizes " + p.sizes;
    document.getElementById("swq-error").textContent = "";
    setButtons("Pick a size", false);
    var terms = [
      "One pair of " + p.name + " for $" + p.price + ". Nothing is charged until you check out.",
      "Free US shipping on this order.",
      "365 days of free returns and exchanges.",
      "One-time purchase. No subscription, nothing recurring."
    ];
    document.getElementById("swq-terms").innerHTML = terms.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("");
    Array.prototype.forEach.call(root.querySelectorAll(".swq-tile"), function (el) {
      var on = el.dataset.h === h;
      el.classList.toggle("sel", on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
    });
    loadSizes(h, p);
  }

  function loadSizes(h, p) {
    fetch("/products/" + encodeURIComponent(h) + ".js").then(function (r) {
      if (!r.ok) throw new Error("product " + r.status);
      return r.json();
    }).then(function (prod) {
      if (h !== handle) return;
      product = prod;
      var names = (prod.options || []).map(function (o) { return (o.name || o).toString().toLowerCase(); });
      var idx = Math.max(0, names.indexOf("size"));
      var live = prod.price / 100;
      document.getElementById("swq-p-price").textContent = "$" + (live % 1 ? live.toFixed(2) : live);
      // XXS was retired for adults in 2026 (claims library C-PROD-16), so it is never offered here.
      var variants = prod.variants.filter(function (v) { return v.available && String(v["option" + (idx + 1)]).toUpperCase() !== "XXS"; });
      var box = document.getElementById("swq-sizes");
      if (!variants.length) {
        document.getElementById("swq-size-note").textContent = "Sold out right now. Try one of the others below.";
        return;
      }
      box.innerHTML = variants.map(function (v) {
        return '<button type="button" class="swq-size" data-v="' + v.id + '">' + esc(v["option" + (idx + 1)]) + "</button>";
      }).join("");
      var hasXS = variants.some(function (v) { return String(v["option" + (idx + 1)]).toUpperCase() === "XS"; });
      document.getElementById("swq-size-note").textContent = "Showing sizes in stock now." + (hasXS ? " " + DATA.quiz.size_note : "");
      Array.prototype.forEach.call(box.querySelectorAll(".swq-size"), function (b) {
        b.addEventListener("click", function () {
          Array.prototype.forEach.call(box.querySelectorAll(".swq-size"), function (x) { x.classList.remove("sel"); });
          b.classList.add("sel");
          variantId = Number(b.dataset.v);
          setButtons("Add to bag · " + document.getElementById("swq-p-price").textContent, true);
        });
      });
    }).catch(function (err) {
      // Fall back to the product page, which has its own size picker.
      console.warn("live sizes unavailable", err);
      document.getElementById("swq-size-note").textContent = "Sizes " + p.sizes + ". Choose yours on the next page.";
      setButtons("Choose my size", true);
      variantId = "pdp";
    });
  }

  function addToBag() {
    if (adding) return;
    if (!variantId) {
      var box = document.getElementById("swq-sizes");
      box.scrollIntoView({ behavior: "smooth", block: "center" });
      box.classList.remove("swq-flash"); void box.offsetWidth; box.classList.add("swq-flash");
      return;
    }
    if (variantId === "pdp") { location.href = "/products/" + handle; return; }
    adding = true;
    setButtons("Adding…", false);
    log("lp_click", { answer_id: String(variantId) });
    if (window.fbq) window.fbq("trackCustom", "QuizShopClick", { content_category: aid, content_ids: [handle] });
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _quiz_archetype: aid } }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || ("cart " + r.status)); });
      // Order-level attribute so revenue can be split by quiz result in Shopify and Triple Whale.
      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: { quiz_archetype: aid, quiz_sid: sid } })
      }).catch(function (err) { console.warn("cart attribute failed", err); });
    }).then(function () {
      location.href = "/cart";
    }).catch(function (err) {
      console.error("add to bag failed", err);
      document.getElementById("swq-error").textContent = "That size just sold out or the bag hiccuped. Try another size.";
      adding = false;
      setButtons("Add to bag", true);
    });
  }

  // Data ships as a script that sets window.SWQ_DATA (Shopify's CDN won't serve .json theme assets).
  var dataReady = window.SWQ_DATA ? Promise.resolve(window.SWQ_DATA) : fetch(CFG.data).then(function (r) {
    if (!r.ok) throw new Error("data " + r.status);
    return r.json();
  });
  dataReady.then(function (d) {
    DATA = d;
    aid = params.get("a");
    if (!Object.prototype.hasOwnProperty.call(DATA.pages, aid)) aid = DATA.quiz.archetype_ids[0];
    PAGE = DATA.pages[aid];
    handle = params.get("p");
    if (!handle || !Object.prototype.hasOwnProperty.call(DATA.quiz.products, handle)) handle = DATA.quiz.default_recommendation[aid];
    render();
    show(handle);
    log("lp_view", {});
  }).catch(function (err) {
    console.error("result page failed to load", err);
    root.innerHTML = '<div class="swq-thinking">Something tripped over its straps. <a href="/collections/all">Shop Swoveralls</a>.</div>';
  });
})();
